export const deepCopy = (value) => {
  if (value == null) {
    return null
  }

  return JSON.parse(JSON.stringify(value))
}
